
import type { SVGProps } from 'react';
import Image from 'next/image';
import { cn } from '@/lib/utils';

export function Logo(props: Omit<React.ComponentProps<typeof Image>, 'src' | 'alt'>) {
  // The style prop is added to resolve the Next.js aspect ratio warning
  // when the image is resized using utility classes.
  return (
    <Image
      src="/logo.png"
      alt="Afri Hustle Hub Logo"
      width={40}
      height={40}
      {...props}
      className={cn("h-10 w-10", props.className)}
    />
  );
}
